import { render, staticRenderFns } from "./select-request-type.vue?vue&type=template&id=405fb378"
import script from "./select-request-type.vue?vue&type=script&lang=ts"
export * from "./select-request-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports